import React, {
    useEffect,
    useRef,
    useState
} from 'react';
import LoadingEllipsis from '../loading-ellipsis/LoadingEllipsis.component';

const TRUST_MARKERS = [
    'Reviewing your request',
    'Determining the best approach',
    'Reviewing relevant material',
    'Preparing response'
];

export type LoadingReasoningStepsState = {
    currentStepIndex: number;
}

const defaultState: LoadingReasoningStepsState = {
    currentStepIndex: 0,
}

const LoadingReasoningSteps = (): JSX.Element => {
    const [state, setState] = useState<LoadingReasoningStepsState>(defaultState);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setState(prevState => {
                if (prevState.currentStepIndex < TRUST_MARKERS.length - 1) {
                    return {
                        ...prevState,
                        currentStepIndex: prevState.currentStepIndex + 1
                    };
                }
                return prevState;
            });
        }, 3000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    return (
        <div className="u-els-color-n8">
            <span>
                <LoadingEllipsis text={TRUST_MARKERS[state.currentStepIndex]} />
            </span>
        </div>
    );
};

export default LoadingReasoningSteps;
